import { gql } from '@apollo/client'
import { ID } from '../../utils/id'

export interface CompanyFragment {
  id: ID
  name: string
  referralCode: string
  isIpAllowed: boolean
  slug: string
  lang?: string
  logo?: string
  isAdmin: boolean
  isMember: boolean
  isWorker: boolean
  features: string[]
}

export const COMPANY_FRAGMENT = gql`
  fragment Company on Company {
    id
    name
    referralCode: coupon
    isIpAllowed
    slug
    lang
    logo: logoUrl(size: 250)
    isAdmin
    isMember
    isWorker
    features
  }
`
